// Hover Zoom Logic
class MagnifyImage extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('img');
    this.zoomRatio = 2; // Default zoom
    this.init();
  }

  init() {
    if (!this.image) return;

    // Create magnifier glass
    this.glass = document.createElement('div');
    this.glass.setAttribute('class', 'magnifier-glass');
    this.glass.style.position = 'absolute';
    this.glass.style.borderRadius = '50%';
    this.glass.style.border = '1px solid #000'; // Make it visible
    this.glass.style.boxShadow = '0 0 5px rgba(0,0,0,0.2)';
    this.glass.style.width = '150px';
    this.glass.style.height = '150px';
    this.glass.style.pointerEvents = 'none'; // Clicks pass through
    this.glass.style.display = 'none';
    this.glass.style.backgroundRepeat = 'no-repeat';
    this.glass.style.zIndex = '10';
    this.glass.style.backgroundColor = 'rgba(255, 255, 255, 0.9)'; // Fallback

    this.appendChild(this.glass);

    this.addEventListener('mouseenter', this.startZoom.bind(this));
    this.addEventListener('mouseleave', this.stopZoom.bind(this));
    this.addEventListener('mousemove', this.moveZoom.bind(this));
  }

  startZoom() {
    this.image.style.cursor = 'none'; // Hide default cursor
    this.glass.style.display = 'block';
    this.glass.style.backgroundImage = `url('${this.image.src}')`;
    this.glass.style.backgroundSize = `${this.image.width * this.zoomRatio}px ${this.image.height * this.zoomRatio}px`;
  }

  stopZoom() {
    this.image.style.cursor = 'default';
    this.glass.style.display = 'none';
  }

  moveZoom(e) {
    e.preventDefault();
    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Center the glass on cursor
    // But limit it? No, just center it.
    this.glass.style.left = `${x - 75}px`; // 75 is half width
    this.glass.style.top = `${y - 75}px`;

    // Move background image inside glass
    // We want to show the part of image under the cursor
    // If zoom is 2x, background size is 200%.
    // If cursor is at 10% x, backgound position should show 10%x * ratio?

    // Calculate percentage position
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    this.glass.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  }
}

customElements.define('magnify-image', MagnifyImage);
